import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment-jalaali';

export const user = createSlice({
  name: 'user',
  initialState: {
    info: {
      loading: false,
      data: {
        ttl: 0,
      },
      fanSupportTeamId: null,
    },
    banks: {
      loading: false,
      data: [],
    },
    profileTicket: {
      loading: false,
      data: [],
    },

    ticketDetailAttachment: {
      loading: false,
      data: [],
    },
    wallet: {
      loading: false,
      balance: undefined,
      transactions: [],
      transactionsLoading: false,
    }
  },

  reducers: {
    INFO_SUCCESS: (state, action) => {
      return {
        ...state,
        info: {
          data: {...action.payload, ttl: moment().add(10, "minutes").valueOf() },
          loading: false
        }
      }

      // state.info.loading = false
      // state.info.data = { ...state.info.data, ...action.payload }
    },

    RESET_USER: (state, action) => {

      state.info = {
        loading: false,
        data: { FanSupportTeamId: null },
        fanSupportTeamId: null
      }
    },

    USER_LOG_OUT: (state, action) => {
      state.info = {
        loading: false,
        data: { DisplayName: "", Phone: "", FanSupportTeamId: null },
        fanSupportTeamId: null
      }
    },

    GET_BANKID_REQUEST: (state, action) => {
      return {
        ...state,
        banks: {
          loading: true
        }
      }
    },

    GET_BANKID_SUCCESS: (state, action) => {
      return {
        ...state,
        banks: {
          data: action.payload.Banks,
          loading: false
        }

      }
    },

    GET_BANKID_FAIL: (state, action) => {
      return {
        ...state,
        banks: {
          loading: false
        }
      }
    },

    PROFILE_POST_TICKET_SUCCESS: (state, action) => {
      return {
        ...state,
        profileTicket: {
          data: action.payload,
          loading: false
        }
      }
    },

    POST_TICKET_DETAIL_ATTACHMENTS_SUCCESS: (state, action) => {
      return {
        ...state,
        ticketDetailAttachment: {
          data: action.payload,
          loading: false
        }
      }
    },
    GET_USER_BALANCE_SUCCESS: (state, action) => {
      return {
        ...state,
        wallet: {
          ...state,
          loading: false,
          balance: action.payload
        }
      }
    },
    GET_USER_BALANCE_REQUEST: (state, action) => {
      return {
        ...state,
        wallet: {
          ...state,
          loading: true,
        }

      }
    },
    GET_USER_BALANCE_FAIL: (state, action) => {
      return {
        ...state,
        wallet: {
          ...state,
          loading: false,
        }

      }
    },
  },
});
export const {

  INFO_SUCCESS,
  RESET_USER,
  USER_LOG_OUT,
  GET_BANKID_REQUEST,
  GET_BANKID_SUCCESS,
  GET_BANKID_FAIL,
  PROFILE_POST_TICKET_SUCCESS,
  POST_TICKET_DETAIL_ATTACHMENTS_SUCCESS,
  GET_USER_BALANCE_FAIL,
  GET_USER_BALANCE_REQUEST,
  GET_USER_BALANCE_SUCCESS
} = user.actions;
export default user.reducer;